@file: UseSerializers(BigDecimalSerializer::class)

package net.sergeych.ugdx.shared.trader

import net.sergeych.ugdx.shared.BigDecimalSerializer
import com.ionspin.kotlin.bignum.decimal.BigDecimal
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseSerializers

@Serializable
data class OrderbookSnapshot(
    val currencyPair: CurrencyPair,
    val createdAt: Instant,
    val orders: List<TradeOrder>,
    val lastRate: BigDecimal? = null,
    val lastChangeDirection: Int? = null
)